import React from 'react'
import { inject, observer } from 'mobx-react'
import { Card, Button, Input, Layout, PageHeader, Row, Col, Select, DatePicker, Checkbox } from 'antd'

import LogsList from './LogsList'
import DataAnalyze from './DataAnalyze'
import logTypes from './logTypes'

@inject((store: any) => {
    const { logsStore } = store
    return { logsStore }
})
@observer
export default class extends React.Component<any, any> {
    handleFilterChange = (name, value) => {
        this.props.logsStore.addFilter(name, value)
    }
    handleSubmitSearch = () => {
        this.props.logsStore.getLogsList()
    }

    render() {
        const { filters, errors, resetFilters, resetList } = this.props.logsStore
        const keywords = 'subType' in filters ? logTypes[filters.subType].keywords : undefined
        const types = Object.keys(logTypes).map(
            key =>
                logTypes[key].fieldType === 'type' && (
                    <Select.Option key={key} value={key}>
                        {logTypes[key].title}
                    </Select.Option>
                )
        )
        const subTypes = Object.keys(logTypes).map(
            key =>
                logTypes[key].fieldType === 'subType' && (
                    <Select.Option value={key} key={key}>
                        {logTypes[key].title}
                    </Select.Option>
                )
        )
        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="דוחות פעילות באתר"
                    subTitle={'דוחות פעילות של לקוחות ושגיאות מערכת'}
                />
                <Row gutter={10}>
                    <Col xs={4}>
                        <label>
                            <strong>בחירת סוג דוח</strong>
                        </label>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="בחר סוג דוחות"
                            value={filters && 'type' in filters ? filters.type : undefined}
                            onChange={e => {
                                resetList()
                                resetFilters([
                                    'attributes.keywords',
                                    'attributes.name',
                                    'subType',
                                    'attributes.results'
                                ])
                                this.handleFilterChange('type', e)
                            }}
                        >
                            {types}
                        </Select>
                        {'type' in errors ? (
                            <span style={{ fontWeight: 'bold', color: 'red', width: '100%' }}>* {errors['type']}</span>
                        ) : (
                            ''
                        )}
                        {'type' in filters && filters.type === 'SEARCH' && (
                            <Checkbox
                                style={{ width: '100%' }}
                                onChange={e =>
                                    this.handleFilterChange('attributes.results', e.target.checked ? '0' : false)
                                }
                                checked={!!(filters && 'attributes.results' in filters)}
                            >
                                הצג חיפושים ללא תוצאות
                            </Checkbox>
                        )}
                    </Col>
                    <Col xs={4}>
                        <label>
                            <strong>בחירת תת סוג</strong>
                        </label>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="בחר סוגי חיפוש"
                            value={filters && 'subType' in filters ? filters.subType : undefined}
                            onChange={e => {
                                resetList()
                                resetFilters(['attributes.keywords', 'attributes.name'])
                                this.handleFilterChange('subType', e)
                            }}
                        >
                            {subTypes}
                        </Select>
                        {'subType' in errors ? (
                            <span style={{ fontWeight: 'bold', color: 'red' }}>{errors['subType']}</span>
                        ) : (
                            ''
                        )}
                    </Col>
                    <Col xs={4}>
                        <label>
                            <strong>מספר דוחות (ברירת מחדל 1000)</strong>
                        </label>
                        <Input
                            min={0}
                            max={10000}
                            placeholder="הזן הגבלת מספר תוצאות"
                            onChange={e =>
                                !!(+e.target.value < 50000) && this.handleFilterChange('size', e.target.value)
                            }
                            value={'size' in filters ? filters.size : undefined}
                            type="number"
                        />
                    </Col>
                    {keywords && (
                        <Col xs={4}>
                            <label>
                                <strong>מילות מפתח</strong>
                            </label>
                            <Input
                                placeholder="מילות חיפוש"
                                value={filters[keywords]}
                                onChange={e => this.handleFilterChange(keywords, e.target.value)}
                            />
                        </Col>
                    )}
                    <Col xs={4}>
                        <label>
                            <strong>חיפוש על פי מזהה משתמש</strong>
                        </label>
                        <Input
                            placeholder="הזן מזהה משתמש"
                            value={filters['attributes.user_id']}
                            onChange={e => this.handleFilterChange('attributes.user_id', e.target.value)}
                        />
                    </Col>
                    <Col xs={4}>
                        <label>
                            <strong>חיפוש על פי תאריך</strong>
                        </label>
                        <DatePicker.RangePicker
                            onChange={value => {
                                if (value[0]) this.handleFilterChange('gte', value[0].valueOf())
                                if (value[1]) this.handleFilterChange('lte', value[1].valueOf())
                                if (value.length === 0) resetFilters(['gte', 'lte'])
                            }}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: '0.5rem' }}>
                    <Col xs={6}>
                        <Button
                            onClick={() => {
                                resetList()
                                resetFilters()
                            }}
                            style={{ width: '45%' }}
                        >
                            אפס חיפוש
                        </Button>
                        <Button onClick={this.handleSubmitSearch} style={{ width: '45%' }} type="primary">
                            חפש דוחות
                        </Button>
                    </Col>
                </Row>
                <Row gutter={10} style={{ marginTop: '1rem' }}>
                    <Col xs={15}>
                        <Card title="דוחות חיפושים">
                            <LogsList selectedType={filters.type} />
                        </Card>
                    </Col>
                    <Col xs={9}>
                        <Card title="פילוח נתונים">
                            <DataAnalyze selectedType={filters.type} />
                        </Card>
                    </Col>
                </Row>
            </Layout>
        )
    }
}
